export const getCoords = (geoObjectData) =>
  geoObjectData.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
